import React from 'react';

const ErrorPage = (props) => <div>Where are you trying to go????</div>;

export default ErrorPage;
